import { formatQcStatus } from "./recordDetailsUtils";

const parseLogDate = (value) => {
  if (!value) {
    return null;
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return null;
  }

  return date;
};

export const formatLogTimestamp = (value) => {
  const date = parseLogDate(value);
  if (!date) {
    return value ? String(value) : "-";
  }

  const datePart = date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
  const timePart = date.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

  return `${datePart} at ${timePart}`;
};

export const formatLogDateHeader = (value) => {
  const date = parseLogDate(value);
  if (!date) {
    return "Unknown date";
  }

  return date.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
};

export const formatLogTimeOnly = (value) => {
  const date = parseLogDate(value);
  if (!date) {
    return "-";
  }

  return date.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

const getLogDateKey = (value) => {
  const date = parseLogDate(value);
  if (!date) {
    return "unknown";
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const groupLogsByDate = (logs) => {
  if (!logs?.length) {
    return [];
  }

  const groups = [];

  logs.forEach((log, index) => {
    const dateKey = getLogDateKey(log.timestamp);
    const lastGroup = groups[groups.length - 1];

    if (!lastGroup || lastGroup.dateKey !== dateKey) {
      groups.push({
        dateKey,
        dateLabel: formatLogDateHeader(log.timestamp),
        entries: [{ log, index }],
      });
      return;
    }

    lastGroup.entries.push({ log, index });
  });

  return groups;
};

export const formatLogActionLabel = (action) => {
  if (!action) {
    return "performed an action";
  }

  if (action === "claimed") {
    return "claimed this record";
  }

  if (action === "resolve") {
    return "resolved and sent back to queue";
  }

  if (action.startsWith("submit:")) {
    const status = action.slice("submit:".length).trim();
    if (status === "blocked") {
      return "blocked this record";
    }
    return `submitted as ${formatQcStatus(status).toLowerCase()}`;
  }

  if (action.startsWith("review:")) {
    const decision = action.slice("review:".length).trim();
    if (decision === "checked") {
      return "approved the submission";
    }
    if (decision === "revert") {
      return "reverted the record to the queue";
    }
    return `reviewed: ${formatQcStatus(decision).toLowerCase()}`;
  }

  return action.replace(/_/g, " ");
};

export const shouldShowLogDetails = (action, details) => {
  if (!details || typeof details !== "string") {
    return false;
  }

  const trimmed = details.trim();
  if (!trimmed) {
    return false;
  }

  if (action === "claimed" && trimmed.toLowerCase() === "claimed") {
    return false;
  }

  return true;
};
